import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/tag`;

export class Tag {
  static async getTagsByType(type = 'document', params) {
    try {
      const profileId = params?.profileId;
      const response = await axios.get(`${BASE_URL}/${type}`, {
        headers: Contexture.getHeaders(profileId),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async getDocumentTags(params) {
    return this.getTagsByType('document', params);
  }
}
